import React from 'react';
import { IPageContainer } from './interfaces';
import { Box, CustomTheme, useTheme } from '@mui/material';

export const PageContainer: React.FC<IPageContainer> = ({
  children,
  sx,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: theme.portal.maxWidth,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
